import { AnyAction } from 'redux';
import { findAtcs } from '~/Api/Analytics/Autocomplete/Atc';
import { invokeApi, tryResolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { selectAtcs } from './reducer';

export function loadAtcs(filter: string): ThunkAction<Promise<void>, AnyAction> {
	return async (dispatch, getState) => {
		const normalizedFilter = filter.slice(0, 1);
		const atcs = selectAtcs(getState().medicinalBrandsAnalyticsAtcAutocomplete, normalizedFilter);
		await (atcs || dispatch(fetchAtcs(normalizedFilter)));
	};
}

export function fetchAtcs(filter: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findAtcs, filter));
		dispatch({ type: ActionTypes.request, request, filter });
		tryResolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				filter,
				atcs: response?.items,
			})
		);
	};
}

export function fetchAtcsByCodes(codes: string[]): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findAtcs, null, codes));
		const filter = codes.join(',');
		dispatch({ type: ActionTypes.request, request, filter });
		tryResolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				filter,
				atcs: response?.items,
			})
		);
	};
}
